$(function(){
  $('[data-check-all]').each(function() {
    var $parent = $(this);
    $checkAll = $parent.find('input.check-all');
    $checkAllInputs = $parent.find('input.check-all-input');

    $checkAll.on('click', function() {
      var checked = this.checked;

      $checkAllInputs.each(function() {
        if (this.disabled) return;

        $(this).prop('checked', checked);
      });
    });

    $checkAllInputs.closest('tr').on('click', function(event) {
      var checkbox = $(this).find('input.check-all-input')[0];

      if (checkbox.disabled) return;

      if (event.target != checkbox) {
        checkbox.checked = !checkbox.checked;
      }

      var checked = checkbox.checked;


      if (!checked) {
        $checkAll[0].checked = false;
      } else {
        $checkAllInputs.each(function() {
          checked = checked && this.checked;
        });

        $checkAll[0].checked = checked;
      }
    });
  });
});